import * as yup from 'yup';
import { Footer } from '@web/components';
import { nullableImageFromCMSSchema, richTextFromCMSSchema } from '../schemas';

export const component = Footer;

export const schema = yup
  .object({
    copyright: yup.string().required(),
    message: yup.string().required(),
    variant: yup.mixed().oneOf(['simplified', 'full']).required(),
    backgroundColor: yup.string().nullable(),
    bottomLinks: yup.array(
      yup.object({
        path: yup.string().required(),
        text: yup.string().required(),
      }),
    ),
    columnLinks: yup.array(
      yup.object({
        links: yup.array(
          yup.object({
            path: yup.string().required(),
            text: yup.string().required(),
            icon: nullableImageFromCMSSchema,
            blurb: yup.string(),
          }),
        ),
        hideIfAccount: yup.boolean().nullable(),
        businessHours: richTextFromCMSSchema,
        content: richTextFromCMSSchema,
        legalBlurb: richTextFromCMSSchema,
        title: yup.string().required(),
      }),
    ),
    connectColumn: yup
      .object({
        title: yup.string(),
        appStoreSectionTitle: yup.string().nullable(),
        socialIcons: yup.array(
          yup.object({
            image: nullableImageFromCMSSchema,
            targetUrl: yup.string().nullable(),
            opensInNewTab: yup.boolean(),
          }),
        ),
        appStoreIcons: yup.array(
          yup.object({
            image: nullableImageFromCMSSchema,
            targetUrl: yup.string().nullable(),
            opensInNewTab: yup.boolean(),
          }),
        ),
      })
      .nullable(),
    textLegalBlurb: richTextFromCMSSchema.nullable(),
    showBottomLogo: yup.boolean().nullable(),
  })
  .transform(value => ({
    copyright: value.copyright,
    message: value.message,
    variant: value.variant,
    backgroundColor: value.background_color || undefined,
    bottomLinks: value.bottom_links.map(link => ({
      path: link.link_target.url,
      text: link.link_text,
    })),
    columnLinks: value.column_links.map(
      ({ title, business_hours, content, legal_blurb, links }) => ({
        title,
        businessHours: business_hours,
        content,
        legalBlurb: legal_blurb,
        links: links.map(link => ({
          path: link.link_target.url,
          text: link.link_text,
          icon: link.icon,
          blurb: link.blurb,
        })),
      }),
    ),
    connectColumn: value.connect_column?.[0]
      ? {
          title: value.connect_column[0].title,
          appStoreSectionTitle:
            value.connect_column[0].app_store_section_title || null,
          socialIcons: (value.connect_column[0].social_icons || []).map(
            icon => ({
              image: icon.image,
              targetUrl: icon.target_url?.url,
              opensInNewTab: icon.opens_in_new_tab ?? true,
            }),
          ),
          appStoreIcons: (value.connect_column[0].app_store_icons || []).map(
            icon => ({
              image: icon.image,
              targetUrl: icon.target_url?.url,
              opensInNewTab: icon.opens_in_new_tab ?? true,
            }),
          ),
        }
      : undefined,
    textLegalBlurb: value.text_legal_blurb || null,
    showBottomLogo: value.show_bottom_logo ?? true,
  }));
